import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  EcommerceWebExperts,
  EcommerceWebProjects,
  EcommerceWebGoodfirms,
  WebClutchRatingLogo,
  WebAppIndustryRating,
} from "../../../app-constants";
import { LogisticsAppBusinessAnalyst } from "../../../app-constants-updated";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/react-native-updated/rating_react_back.webp";

const Ratingusa = () => {
  return (
    <div
      className="rating_usa rating_web_dev tekrevol_dark_bg rating_dubai rating_on_demand p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={3}
            xxl={3}
            className="mb-xl-0 mb-md-4 mb-0 ps-xl-3"
          >
            <div className="rating_box">
              <div className="rating-svg">
                <StaticImage
                  src="../../images/locationgcc/dubai_new/app_dev_dubai.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={95}
                />
              </div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  60+
                </div>
                <p>Expert Developers</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">
                <StaticImage
                  src="../../images/locationgcc/dubai_new/live_apps_dubai.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={96}
                />
              </div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  200+
                </div>
                <p>Successful Projects</p>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={3}
            xxl={3}
            className="mb-xl-0 mb-md-4 mb-0 ps-xl-3"
          >
            <div className="rating_box">
              <div className="rating-svg">{LogisticsAppBusinessAnalyst}</div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  12+
                </div>
                <p>Business Analysts</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="ps-xl-4">
            <div className="rating_box">
              <div className="rating-svg">{WebClutchRatingLogo}</div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  4.8
                </div>
                <p>Clutch Rating</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ratingusa;
